/* ==========================================================================
   ps.js — Peakspan H2 homepage behaviour (peakspanh2.com)
   Ported from the shopgeroprotect SG-template (gp-sg.js) and adapted for a
   static site. Namespaced ps- ; no external requests; idempotent.
   Owns: hero video (keep-playing + watchdog + mobile swap), ferris pill
   rail, slide-over depth, scroll cue, FAQ accordion, tech stack cards,
   colorway selector, compare toggle, flowing slogans (#ps-flow ripple),
   mailing-list popup (mailto compose) + newsletter band hand-off.
   The pre-order basket lives in ps-preorder.js; the PPB fill animation
   lives in ppb-anim.js.
   ========================================================================== */
(function () {
  'use strict';

  if (window.psInit) return;
  window.psInit = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ------------------------------------------------------------------
     Hero video: keep-playing guard — some browsers pause autoplay loops
     on tab switches or memory pressure; resume unless deliberately
     paused (covered by the sheet) or reduced motion is on.
  ------------------------------------------------------------------ */
  (function psKeepPlaying() {
    var v = document.querySelector('.ps-hero__video');
    if (!v) return;
    v.addEventListener('pause', function () {
      setTimeout(function () {
        if (v.paused && !v.ended && v.dataset.psCovered !== '1' && !reducedMotion.matches && !document.hidden) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      }, 150);
    });
  })();

  /* ------------------------------------------------------------------
     Hero video watchdog: if the 1080p file errors or is still not
     buffering after 6s (or rebuffers 3x inside 30s), step down to the
     720p file once. A slow-but-progressing load is left alone.
  ------------------------------------------------------------------ */
  (function psVideoWatchdog() {
    var v = document.querySelector('.ps-hero__video');
    if (!v) return;
    var stepped = false;
    function stepDown(reason) {
      if (stepped) return;
      var coveredPause = v.dataset.psCovered === '1';
      if (reason !== 'rebuffer' && (v.readyState >= 2 || (v.buffered && v.buffered.length > 0))) return;
      var alt = v.dataset.mobileMp4;
      if (!alt || (v.currentSrc || '').indexOf(alt.split('?')[0].split('/').pop()) !== -1) return;
      stepped = true;
      Array.prototype.slice.call(v.querySelectorAll('source')).forEach(function (s) {
        s.parentNode.removeChild(s);
      });
      var s = document.createElement('source');
      s.setAttribute('src', alt);
      s.setAttribute('type', 'video/mp4');
      v.appendChild(s);
      v.load();
      if (!coveredPause) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    v.addEventListener('error', function () { stepDown('error'); }, true);
    setTimeout(function () { stepDown('timeout'); }, 6000);
    var waits = 0, born = Date.now();
    v.addEventListener('waiting', function () {
      if (Date.now() - born < 30000 && ++waits >= 3) stepDown('rebuffer');
    });
    /* whenever data becomes ready and nothing intentionally paused us, play —
       covers autoplay promises aborted by load()/source recovery */
    v.addEventListener('canplay', function () {
      if (v.paused && v.dataset.psCovered !== '1' && !reducedMotion.matches) {
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    });
  })();

  /* ------------------------------------------------------------------
     Mobile source swap: phones get the 720p file up front.
  ------------------------------------------------------------------ */
  (function psMobileSrcSwap() {
    var v = document.querySelector('.ps-hero__video');
    if (!v || !v.dataset.mobileMp4 || window.innerWidth >= 750) return;
    var srcs = Array.prototype.slice.call(v.querySelectorAll('source'));
    srcs.forEach(function (s) {
      if ((s.getAttribute('type') || '').indexOf('mp4') !== -1) s.setAttribute('src', v.dataset.mobileMp4);
      else s.parentNode.removeChild(s);
    });
    v.load();
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  })();

  /* ------------------------------------------------------------------
     Smooth scroll helper
  ------------------------------------------------------------------ */
  function psScrollTo(target) {
    if (!target) return;
    target.scrollIntoView({
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  /* ------------------------------------------------------------------
     Hero pill rail — ferris wheel (desktop) / snap row cycle (mobile).
     Pills rotate through vertical slots every 3s; the center slot is
     "active" (glow + chrome check). Hover/focus pauses; a click pauses
     6s and smooth-scrolls to the pill's section.
  ------------------------------------------------------------------ */
  function psInitHeroPills(hero) {
    var rail = hero.querySelector('.ps-hero__pills');
    if (!rail) return;

    var pills = Array.prototype.slice.call(rail.querySelectorAll('.ps-pill-nav'));
    var n = pills.length;
    if (!n) return;

    var desktop = window.matchMedia('(min-width: 990px)');
    var SLOT = 64;
    var WRAP_FADE_MS = 360;
    var center = Math.floor(n / 2);
    var slots = pills.map(function (_, i) { return i; });
    var mobileIndex = 0;
    var paused = false;
    var pauseUntil = 0;
    var wheelOn = false;

    /* 3D drum (R2, 2026-08-25): each pill sits on a rolodex cylinder.
       Distance from the center slot maps to a rotateX tilt + translateZ
       depth, so rows curve away above and below the active pill. */
    function styleFor(slot) {
      var d = Math.abs(slot - center);
      if (d === 0) return { scale: 1.07, opacity: 1, rx: 0, z: 48 };
      if (d === 1) return { scale: 1, opacity: 0.9, rx: 17, z: 4 };
      if (d === 2) return { scale: 0.94, opacity: 0.68, rx: 32, z: -52 };
      return { scale: 0.9, opacity: 0.4, rx: 46, z: -110 };
    }

    function transformFor(slot) {
      var st = styleFor(slot);
      var sign = slot < center ? 1 : (slot > center ? -1 : 0);
      return 'translateY(' + slot * SLOT + 'px) translateZ(' + st.z + 'px) rotateX(' + (sign * st.rx) + 'deg) scale(' + st.scale + ')';
    }

    function applyPill(i) {
      var s = slots[i];
      var st = styleFor(s);
      var p = pills[i];
      p.style.transform = transformFor(s);
      p.style.opacity = String(st.opacity);
      p.classList.toggle('ps-active', s === center);
    }

    function applyAll() {
      for (var i = 0; i < n; i++) applyPill(i);
    }

    function enableWheel() {
      if (wheelOn) return;
      var pillH = pills[0].offsetHeight || 48;
      rail.classList.add('ps-wheel');
      rail.style.height = (SLOT * (n - 1) + pillH) + 'px';
      wheelOn = true;
      applyAll();
    }

    function disableWheel() {
      if (!wheelOn && !rail.classList.contains('ps-wheel')) return;
      wheelOn = false;
      rail.classList.remove('ps-wheel');
      rail.style.height = '';
      pills.forEach(function (p) {
        p.style.transform = '';
        p.style.opacity = '';
      });
    }

    /* wrap-around pill (bottom -> top): fade out in place, teleport, fade in */
    function wrapAround(i) {
      var p = pills[i];
      p.classList.remove('ps-active');
      p.style.opacity = '0';
      window.setTimeout(function () {
        if (!wheelOn) { return; }
        var s = slots[i];
        var st = styleFor(s);
        p.classList.add('ps-no-trans');
        p.style.transform = transformFor(s);
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (!wheelOn) { return; }
            p.classList.remove('ps-no-trans');
            p.style.opacity = String(st.opacity);
            p.classList.toggle('ps-active', s === center);
          });
        });
      }, WRAP_FADE_MS);
    }

    function rotate() {
      var wrapIdx = -1;
      var i;
      for (i = 0; i < n; i++) {
        if (slots[i] === n - 1) wrapIdx = i;
        slots[i] = (slots[i] + 1) % n;
      }
      for (i = 0; i < n; i++) {
        if (i === wrapIdx) wrapAround(i);
        else applyPill(i);
      }
    }

    function setActiveMobile(i) {
      pills.forEach(function (p, k) {
        p.classList.toggle('ps-active', k === i);
      });
    }

    function tick() {
      if (paused || Date.now() < pauseUntil) return;
      if (wheelOn) {
        rotate();
      } else {
        mobileIndex = (mobileIndex + 1) % n;
        setActiveMobile(mobileIndex);
      }
    }

    function evalMode() {
      if (desktop.matches && !reducedMotion.matches) enableWheel();
      else disableWheel();
    }

    rail.addEventListener('mouseenter', function () { paused = true; });
    rail.addEventListener('mouseleave', function () { paused = false; });
    rail.addEventListener('focusin', function () { paused = true; });
    rail.addEventListener('focusout', function () { paused = false; });

    if (desktop.addEventListener) desktop.addEventListener('change', evalMode);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', evalMode);

    pills.forEach(function (pill, i) {
      var main = pill.querySelector('.ps-pill-nav__main');
      if (!main) return;
      main.addEventListener('click', function () {
        pauseUntil = Date.now() + 6000;
        if (!wheelOn) {
          mobileIndex = i;
          setActiveMobile(i);
        }
        var anchor = pill.getAttribute('data-ps-anchor');
        if (anchor) psScrollTo(document.getElementById(anchor));
      });
    });

    evalMode();
    if (!wheelOn) setActiveMobile(mobileIndex);
    window.setInterval(tick, 3000);
  }

  /* ------------------------------------------------------------------
     Slide-over depth: as the sheet covers the pinned hero, the hero
     content recedes (scale -> .96, opacity -> .6) and the film pauses
     once fully covered. rAF-throttled, transform/opacity only.
  ------------------------------------------------------------------ */
  function psInitSlideOver(hero) {
    var inner = hero.querySelector('.ps-hero__inner');
    if (!inner) return;
    var video = hero.querySelector('.ps-hero__video');
    var ticking = false;
    var heroH = hero.offsetHeight || 1;
    var videoCovered = false;

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        heroH = hero.offsetHeight || 1;
      }).observe(hero);
    } else {
      window.addEventListener('resize', function () {
        heroH = hero.offsetHeight || 1;
      });
    }

    function update() {
      ticking = false;
      var p = Math.min(1, Math.max(0, window.scrollY / heroH));

      /* battery + decode: stop the film once the sheet fully covers the
         pinned hero (the sticky hero never leaves the viewport, it only
         gets painted over — scroll progress is the only signal). */
      if (video) {
        var covered = p >= 1;
        if (covered !== videoCovered) {
          videoCovered = covered;
          if (covered) {
            video.dataset.psCovered = '1';
            video.pause();
          } else {
            delete video.dataset.psCovered;
            if (!reducedMotion.matches) {
              var pl = video.play();
              if (pl && pl.catch) pl.catch(function () {});
            }
          }
        }
      }

      if (reducedMotion.matches) return;
      inner.style.transform = 'scale(' + (1 - 0.04 * p).toFixed(4) + ')';
      inner.style.opacity = (1 - 0.4 * p).toFixed(3);
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', function () {
        if (reducedMotion.matches) {
          inner.style.transform = '';
          inner.style.opacity = '';
        }
      });
    }

    update();
  }

  /* ------------------------------------------------------------------
     Hero scroll cue → the sheet
  ------------------------------------------------------------------ */
  function psInitScrollCue(hero) {
    var cue = hero.querySelector('.ps-hero__scroll-cue');
    if (!cue) return;
    cue.addEventListener('click', function () {
      var sheet = document.querySelector('.ps-sheet');
      if (sheet) psScrollTo(sheet);
    });
  }

  /* ------------------------------------------------------------------
     FAQ accordion — single open, grid-rows pattern (no height reads)
  ------------------------------------------------------------------ */
  function psInitFaq(root) {
    var questions = Array.prototype.slice.call(root.querySelectorAll('.ps-faq__q'));

    function close(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.classList.remove('ps-open');
    }

    function open(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'true');
      if (panel) panel.classList.add('ps-open');
    }

    questions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        questions.forEach(close);
        if (!isOpen) open(btn);
      });
    });
  }

  /* ------------------------------------------------------------------
     Tech stack cards — "Inside the chamber" (#ps-tech). Each card head
     toggles its own detail panel; same grid-rows pattern as the FAQ,
     but cards expand independently (specs, not an accordion).
  ------------------------------------------------------------------ */
  function psInitTech(root) {
    var heads = Array.prototype.slice.call(root.querySelectorAll('.ps-tech-card__head'));
    heads.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) panel.classList.toggle('ps-open', !isOpen);
      });
    });
  }

  /* ------------------------------------------------------------------
     Colorway selector — 6 real supplier colours. Swaps the colorway
     <picture> sources + label; aria-pressed tracks the active dot.
  ------------------------------------------------------------------ */
  function psInitColorways(root) {
    var pic = root.querySelector('.ps-colorways__pic picture');
    var img = root.querySelector('.ps-colorways__pic img');
    var label = root.querySelector('.ps-colorways__label output');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ps-swatch'));
    if (!img || !dots.length) return;

    function select(dot) {
      var key = dot.getAttribute('data-ps-color');
      var name = dot.getAttribute('data-ps-color-name') || key;
      dots.forEach(function (d) { d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'); });
      if (label) label.textContent = name;
      var base = 'assets/img/h88-front-' + key + '-600w';
      if (pic) {
        Array.prototype.slice.call(pic.querySelectorAll('source')).forEach(function (s) {
          var type = s.getAttribute('type') || '';
          if (type.indexOf('avif') !== -1) s.setAttribute('srcset', base + '.avif');
          else if (type.indexOf('webp') !== -1) s.setAttribute('srcset', base + '.webp');
        });
      }
      img.setAttribute('src', base + '.png');
      img.setAttribute('alt', 'H2 Quantum Flask in ' + name.toLowerCase());
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { select(dot); });
    });
  }

  /* ------------------------------------------------------------------
     Compare toggle — Flask / Both / Pitcher. Dims the other column on
     desktop, hides it on mobile (CSS reads data-ps-view).
  ------------------------------------------------------------------ */
  function psInitCompare(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.ps-cmp__toggle button'));
    if (!buttons.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        root.setAttribute('data-ps-view', btn.getAttribute('data-ps-cmp') || 'both');
      });
    });
  }

  /* ------------------------------------------------------------------
     Flowing slogans (#ps-flow): three streams drift via CSS; every word
     gets a JS "water" transform — a gentle sine bob plus a pointer
     ripple that pushes nearby words away and lets them spring back.
     Transform-only writes inside one rAF (reads batched before writes),
     passive listeners, loop runs only while the section is in view.
     Reduced motion: static rows, no rAF loop at all.
  ------------------------------------------------------------------ */
  function psInitFlow(section) {
    if (reducedMotion.matches) return;
    var words = Array.prototype.slice.call(section.querySelectorAll('.ps-flow__word'));
    if (!words.length) return;

    var RADIUS = 150;       // px — pointer influence radius
    var PUSH = 34;          // px — max ripple displacement
    var pointer = { x: -9999, y: -9999, active: false };
    var state = words.map(function (w, i) {
      return { el: w, ox: 0, oy: 0, phase: (i * 0.7) % (Math.PI * 2) };
    });
    var running = false;
    var rafId = 0;

    section.addEventListener('pointermove', function (e) {
      pointer.x = e.clientX; pointer.y = e.clientY; pointer.active = true;
    }, { passive: true });
    section.addEventListener('pointerleave', function () {
      pointer.active = false;
    }, { passive: true });

    function frame(now) {
      rafId = 0;
      var i, s, r, cx, cy, dx, dy, d, f, tx, ty;
      /* reads first (getBoundingClientRect), then writes (transform) */
      var rects = [];
      if (pointer.active) {
        for (i = 0; i < state.length; i++) rects.push(state[i].el.getBoundingClientRect());
      }
      for (i = 0; i < state.length; i++) {
        s = state[i];
        tx = 0; ty = 0;
        if (pointer.active) {
          r = rects[i];
          cx = r.left + r.width / 2; cy = r.top + r.height / 2;
          dx = cx - pointer.x; dy = cy - pointer.y;
          d = Math.sqrt(dx * dx + dy * dy);
          if (d < RADIUS && d > 0.001) {
            f = 1 - d / RADIUS;
            f = f * f; /* ease the falloff so the ripple feels watery */
            tx = (dx / d) * PUSH * f;
            ty = (dy / d) * PUSH * f;
          }
        }
        /* spring toward the ripple target (lerp = smooth ripple + settle) */
        s.ox += (tx - s.ox) * 0.14;
        s.oy += (ty - s.oy) * 0.14;
        var bob = Math.sin(now * 0.0014 + s.phase) * 5;
        s.el.style.transform = 'translate(' + s.ox.toFixed(2) + 'px,' + (s.oy + bob).toFixed(2) + 'px)';
      }
      if (running) rafId = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      running = true;
      rafId = requestAnimationFrame(frame);
    }
    function stop() {
      running = false;
      if (rafId) { cancelAnimationFrame(rafId); rafId = 0; }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) start(); else stop();
        });
      }).observe(section);
    } else {
      start();
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', function () {
        if (reducedMotion.matches) {
          stop();
          state.forEach(function (s) { s.el.style.transform = ''; });
        } else {
          start();
        }
      });
    }
  }

  /* ------------------------------------------------------------------
     Mailing-list popup: silver dialog, auto-opens once per visitor
     after the first scroll (localStorage-gated), also opened by the
     newsletter band. "Join" composes a mailto to info@peakspanh2.com —
     the mailbox autoresponder sends the confirmation reply.
  ------------------------------------------------------------------ */
  function psInitMailPop() {
    var dialog = document.getElementById('ps-mailpop');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var form = document.getElementById('ps-mailpop-form');
    var email = form ? form.querySelector('input[type="email"]') : null;
    var KEY = 'psMailpopSeen';

    function seen() {
      try { return localStorage.getItem(KEY) === '1'; } catch (e) { return true; }
    }
    function markSeen() {
      try { localStorage.setItem(KEY, '1'); } catch (e) { /* noop */ }
    }
    function open(prefill) {
      markSeen();
      if (prefill && email) email.value = prefill;
      if (!dialog.open) dialog.showModal();
      if (email) email.focus();
    }

    /* auto-open once, shortly after the visitor first scrolls */
    if (!seen()) {
      window.addEventListener('scroll', function () {
        window.setTimeout(function () { if (!dialog.open) open(); }, 1400);
      }, { passive: true, once: true });
    }

    /* overlay click closes (the card itself swallows its clicks) */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    var closeBtn = dialog.querySelector('[data-ps-mailpop-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var addr = email ? email.value.trim() : '';
        var href = 'mailto:info@peakspanh2.com' +
          '?subject=' + encodeURIComponent('Mailing list signup') +
          '&body=' + encodeURIComponent(
            'Please add me to the Peakspan H2 mailing list.\n\nMy email: ' + addr + '\n');
        dialog.close();
        window.location.href = href;
      });
    }

    /* newsletter band hands off to the popup (email carried over) */
    var band = document.getElementById('ps-newsletter-form');
    var note = document.getElementById('ps-newsletter-note');
    if (band) {
      band.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!band.checkValidity()) { band.reportValidity(); return; }
        var v = band.querySelector('input[type="email"]');
        if (note) note.hidden = false;
        open(v ? v.value.trim() : '');
      });
    }
  }

  /* ------------------------------------------------------------------
     Newsletter fallback: when the popup can't run (no <dialog>), keep
     the honest note that explains the mailto flow.
  ------------------------------------------------------------------ */
  function psInitNewsletterFallback() {
    var dialog = document.getElementById('ps-mailpop');
    if (dialog && typeof dialog.showModal === 'function') return; /* popup owns it */
    var form = document.getElementById('ps-newsletter-form');
    var note = document.getElementById('ps-newsletter-note');
    if (!form || !note) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      note.hidden = false;
    });
  }

  /* ------------------------------------------------------------------
     Boot
  ------------------------------------------------------------------ */
  function psBoot() {
    document.querySelectorAll('.ps-hero').forEach(function (hero) {
      psInitHeroPills(hero);
      psInitScrollCue(hero);
      psInitSlideOver(hero);
    });
    document.querySelectorAll('.ps-faq').forEach(psInitFaq);
    document.querySelectorAll('.ps-tech').forEach(psInitTech);
    document.querySelectorAll('.ps-colorways').forEach(psInitColorways);
    document.querySelectorAll('.ps-cmp').forEach(psInitCompare);
    document.querySelectorAll('.ps-flow').forEach(psInitFlow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', psBoot);
  } else {
    psBoot();
  }
})();
